(function () {
    'use strict';

    angular
        .module('app')
        .controller('companiesController', ['$cookies','$uibModal','accountsService', 'companyService', companiesController]);


    function companiesController($cookies,$uibModal,accountsService, companyService) {
        /* jshint validthis:true */
        var vm = this;
        vm.model = {}

        vm.waiting = false;
        vm.filterApplied = false;

        vm.filter = {
            name: '',
            page: 1,
            take: 20
        };

        activate();

        vm.getCompanies = getCompanies;
        vm.clearFilter = clearFilter;
        vm.pageChanged = pageChanged;
        vm.filterCompanies = filterCompanies;
        vm.showCreateCompanyModal = showCreateCompanyModal;

        function activate() {
           
            vm.model = accountsService.getAuthenticatedAccount().then(function (response) {

                vm.model.isAdmin = (response.accountType === AccountType.Admin || response.accountType === AccountType.SuperAdmin);
                vm.model.isPartnerAdmin = response.accountType === AccountType.Partner || response.accountType === AccountType.PartnerSuperAdmin;
                vm.model.isPartnerSuperAdmin = response.accountType === AccountType.PartnerSuperAdmin;
                vm.model.isSuperAdmin = (response.accountType === AccountType.SuperAdmin);
                vm.model.isCompanyAdmin = response.accountType === AccountType.Company;
                vm.model.authenticatedAccountId = response.accountId;
                vm.model.partnerCode = response.partnerCode;
            });

       

            var searchValue = $cookies.get("SsoCompanySearch");
            vm.filter.name = searchValue;
            pageChanged();
           
        }

        function filterCompanies() {
            vm.filterApplied = true;
            vm.filter.page = 1;
            pageChanged();
        }

        function getCompanies(name, page, take) {
            vm.waiting = true;

            $cookies.put("SsoCompanySearch", name);

            companyService.getCompanies(name, page, take)
                .then(function(response) {
                    vm.companies = response;
                });

            vm.waiting = false;
        }

        function pageChanged() {
            getCompanies(vm.filter.name, vm.filter.page, vm.filter.take);
        }

        function clearFilter() {
            vm.filter = {
                name: '',
                page: 1,
                take: 20
            };
            $cookies.put("SsoCompanySearch", '');
            vm.filterApplied = false;
            pageChanged();
        }

        function showCreateCompanyModal() {
            $uibModal.open({
                templateUrl: 'assets/templates/modals/create_company.html',
                controller: 'createCompanyController',
                size: 'lg'
            });
        }

    }
})();
